import Handlebars from "handlebars/dist/handlebars.js";

var statistics = (function () {

    var dashboard = $('body.dashboard'),
        statisticsTable = $('.t-statistic');

    if (statisticsTable.length > 0) {
        var main = $('#main'),
            statisticsTableData = statisticsTable.data(),
            source = $("#statistic-reports-template").html(),
            template = Handlebars.compile(source),
            cl = new CanvasLoader('t-statistic-loader');

        cl.setDiameter(20);
        cl.setDensity(17);
        cl.setRange(1.1);
        cl.setSpeed(1);
        cl.setColor('#cdcdcd');
        cl.setFPS(24);

        if (dashboard.length === 0) {
            setTimeout(function () {
                getReports(100);
            }, 100);
        } else {
            setTimeout(function () {
                getReports(7);
            }, 100);
        }

        function getReports(pageSize) {
            cl.show();

            var data = {
                "pagesize": pageSize,
                "viewingpageid": statisticsTableData.viewingpage
            };

            var ajaxRequest = $.ajax({
                url: SETTINGS.services.admin.methods.getReports,
                data: JSON.stringify(data)
            });

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);
        }

        function doneHandler(response) {
            cl.hide();

            if (response.length > 0) {
                var html = template(response);
                statisticsTable.find('tbody').html(html);
            }
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            cl.hide();
        }
    }
})();